var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPointerCursor = function SvgPointerCursor(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9333EA",
    d: "M6.908 1.894c-.902-.226-1.625-.406-2.201-.495-.582-.09-1.12-.107-1.611.085-.74.29-1.324.875-1.614 1.614-.192.49-.175 1.029-.085 1.61.089.577.27 1.3.495 2.202l.903 3.611c.195.782.347 1.387.477 1.836.124.428.252.806.43 1.067a2.848 2.848 0 0 0 4.58.17c.197-.246.353-.614.509-1.032.163-.438.359-1.03.612-1.795l.005-.014c.097-.296.129-.387.167-.466.149-.31.4-.561.71-.71.079-.038.17-.07.466-.167l.014-.005c.765-.253 1.357-.449 1.795-.612.418-.156.786-.312 1.033-.509a2.848 2.848 0 0 0-.17-4.58c-.261-.178-.64-.306-1.068-.43-.45-.13-1.054-.282-1.835-.477l-3.612-.903Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPointerCursor);
export default ForwardRef;